// ! Need to update this when we have multiple tenants
export const BASE_URL = ''

export const ID_TOKEN_STALE_TIME = 1000 * 60 * 15 // 15 minutes
export const DEFAULT_STALE_TIME = 1000 * 60 * 5 // 5 minutes
export const USER_INFO_STALE_TIME = 1000 * 60 * 2 // 2 minutes
export const DOCUMENT_STALE_TIME = 0 // 0 seconds
export const VIDEO_URL_STALE_TIME = 1000 * 60 * 60 // 1 hour

export const REFRESH_INTERVAL = 1000 * 30 // 30 seconds
export const PROCESSING_POLL_INTERVAL = 1000 * 5 // 5 seconds

export const VIRTUALIZATION_THRESHOLD = 20

// Server-enforced cap on items per /batch/thumbnails request.
export const BATCH_THUMBNAILS_MAX_ITEMS = 10

export const FLEX_SESSION_TIMEOUT_MS = 1000 * 60 * 60 // 60 minutes
export const FLEX_SESSION_ACTIVITY_KEY = 'flex-session-last-activity'
export const FLEX_SESSION_BROADCAST_CHANNEL = 'flex-session-timeout'
